import { render, staticRenderFns } from "./ForSellerHeader.vue?vue&type=template&id=4486a1e0&scoped=true&"
import script from "./ForSellerHeader.vue?vue&type=script&lang=js&"
export * from "./ForSellerHeader.vue?vue&type=script&lang=js&"
import style0 from "./ForSellerHeader.vue?vue&type=style&index=0&id=4486a1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4486a1e0",
  null
  
)

export default component.exports